import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';


import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';


const styles = StyleSheet.create({
  
  table: {
    marginTop: 10,
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles (adjust widths for each column)
  nestedCol: {
    width: '25%', // First column with smaller width
  },
  header: {
    width: '100%',
  }
 

});





const PensionAnnexure2 = ({ result }) => {
  const calculation = result?.calculation?.[0] ?? {};

const grossServiceObj =
  calculation.grossService ?? { years: 0, months: 0, days: 0 };

const pensionableServiceObj =
  calculation.pensionableService ?? { years: 0, months: 0, days: 0 };

const nonQualifyingServiceObj =
  result?.nonQualifyingService ?? { years: 0, months: 0, days: 0 };

const grossService = result.basicPay + result.DA + result.HRA + result.CLA + result.TRA + result.splPay
  const tableData4 = [
    ['Last Basic Pay', result.basicPay, 'Dearness  Allowance', result.DA],
    ['H.R.A.', result.HRA, 'C.L.A.', result.CLA],
    ['Transport Allowance', result.TRA, 'Special Pay',result.splPay], 
    ['Gross Emoluments',grossService ],

];
 const serviceDetails = [
  ['Last Basic Pay', 'Years', 'Months', 'Days'],
  [
    'Gross Service',
    grossServiceObj.years,
    grossServiceObj.months,
    grossServiceObj.days,
  ],
  [
    'Non Qualifying Service',
    nonQualifyingServiceObj.years,
    nonQualifyingServiceObj.months,
    nonQualifyingServiceObj.days,
  ],
  [
    'Net Qualifying Service',
    pensionableServiceObj.years,
    pensionableServiceObj.months,
    pensionableServiceObj.days,
  ],
];










return (


  <View size="A4" style={style.page}> 
   <Text style={[style.title , style.ArialBlack]}>Annexure A –Departmental Data Sheet</Text>
    <Text style={[style.subtitle, style.ArialItalic]}>(continue...)</Text>
<View style={style.solidLine}></View>
      
      <Text style={style.paragraph}>Date of Medical Certificate invalidating Government Servant – NIL</Text>
      <Text style={style.paragraph}>Date of lodging FIR in absconding cases –NIL </Text>
      <Text style={style.paragraph}>Period of Foreign Service – NIL</Text>
      <Text style={style.paragraph}>Whether contributions received for the above period – NIL</Text>
      <Text style={style.paragraph}>Length of Military Service, if any – NIL </Text>
      <Text style={style.paragraph}>Amount of Military Pension / Gratuity if any: NIL</Text>

<View style={[styles.table, { marginTop: 0 }]}>
  {serviceDetails.map(([label, years, months, days], index) => (
    <View
      style={[
        styles.row,
        index === 0 && styles.headerCell, // ✅ header style for first row
      ]}
      key={index}
    >
      <Text style={[styles.cell, styles.nestedCol]}>
        {label}
      </Text>
      <Text style={[styles.cell, styles.nestedCol]}>
        {years}
      </Text>
      <Text style={[styles.cell, styles.nestedCol]}>
        {months}
      </Text>
      <Text style={[styles.cell, styles.nestedCol]}>
        {days}
      </Text>
    </View>
  ))}
</View>

      
        {/* Table */}
        <View style={[styles.table ,{ marginTop: 5 }]}>
            {/* Header Row */}
            <View style={[styles.row, styles.headerCell]}>
                <Text style={[styles.cell, styles.header]}>Salary details of last month</Text>
            </View>
            
            {/* Table Data */}
            {tableData4.map(([BankName, bankbranch, ifsccode, bankAC], index) => (
                <View style={styles.row} key={index}>
                <Text style={[styles.cell, styles.nestedCol]}>{BankName}</Text>
                <Text style={[styles.cell, styles.nestedCol]}>{bankbranch}</Text>
                <Text style={[styles.cell, styles.nestedCol]}>{ifsccode}</Text>
                <Text style={[styles.cell, styles.nestedCol]}>{bankAC}</Text>
                </View>
            ))}
        </View>
      
  </View>
)};

export default PensionAnnexure2;
